import { DSImageProps } from 'shared-definitions/types'
import { ApiImageProps } from 'data-source/types.wp'
import { imageMapper } from 'data-source/mappers/imageMapper'
import { PLinkMapperOpts } from 'data-source/mappers/pLinkMapper'

export function imageListMapper(
  input: undefined | ApiImageProps[],
  opts: PLinkMapperOpts
): DSImageProps[] | null {
  if (input === undefined) {
    return null
  }

  const images: DSImageProps[] = []
  for (const item of input) {
    const image = imageMapper(item, opts)
    if (image) {
      images.push(image)
    }
  }

  return images.length === 0 ? null : images
}
